import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { Link, graphql, useStaticQuery } from 'gatsby'
import styled from 'styled-components'
import { device } from '../../styles/config'

const Checkbox = styled.li`
  font-size: 0.875rem;
  line-height: 0.875rem;
  letter-spacing: 0.53px;
  margin: 0;
  padding: 0;

  > div {
    margin-left: 1.55rem;

    @media ${ device.sm } {
      margin-left: 1.8rem;
    }
  }

  @media ${ device.md } {
    font-size: 0.75rem;
  }

  @media ${ device.sm } {
    font-size: 0.875rem;
  }

  input {
    position: absolute;
    opacity: 0;

    & + label {
      position: relative;
      cursor: pointer;
      padding: 0;
    }

    /* box */
    & + label:before {
      content: '';
      margin-right: 10px;
      display: inline-block;
      vertical-align: text-top;
      width: 15px;
      height: 15px;
      border: 1px solid #323D74;
      background: transparent;
    }

    /* box checked */
    &:checked + label:before {
      background: #323D74;
    }

    /* disabled state label   */
    &:disabled + label {
      color: rgba(50,61,116,0.3);
      cursor: auto;
    }

    /* disabled box */
    &:disabled + label:before {
      background: transparent;
      border: 1px solid rgba(50,61,116,0.3);
    }

    /* checkbox */
    &:checked + label:after {
      content: '';
      position: absolute;
      left: 2px;
      top: 7px;
      background: white;
      width: 2px;
      height: 2px;
      box-shadow: 
        2px 0 0 white,
        4px 0 0 white,
        4px -2px 0 white,
        4px -4px 0 white,
        4px -6px 0 white,
        4px -8px 0 white;
      transform: rotate(45deg);
    }
  }
}
`

export default Checkbox
